<script lang="ts">
	import { page } from '$app/state';
	import type { SbLink } from '$lib/storyblok/types';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import { type Snippet } from 'svelte';
	import type { HTMLAttributes } from 'svelte/elements';
	interface Props extends HTMLAttributes<HTMLAnchorElement> {
		link: SbLink;
		children: Snippet;
	}

	let { link, children, ...other }: Props = $props();

	function getSlug(url: string) {
		return url.replace(/\/$/, '').split('/').pop();
	}

	let slug = $state(getSlug(link.cached_url));
	let active = $state(page.params.slug === slug);

	$effect(() => {
		active =
			(!page.params.slug && slug === 'open-source-software-disclosure') ||
			page.params.slug === slug;
	});
</script>

<li
	class={[
		'rounded-full',
		{
			'bg-stone-5 text-purple-1 max-lg:bg-white': !active,
			'bg-purple-1 text-stone-5': active
		}
	]}
>
	<a class="inline-block px-6 py-[14px]" href={getSbUrl(link)} {...other}>{@render children()}</a>
</li>
